export enum DobTypeEnum {
  NOACTION = "NOACTION",
  ASKDATE = "ASKDATE",
  ASKYEAR = "ASKYEAR"
}
